import React, { Fragment } from "react";
import FormControl from "@material-ui/core/FormControl";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import LotesGraphQL from "js/graphql/resolvers/lotes.resolver";
import client from "js/App/client.graphql.js";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { _t } from "js/utils/TranslationService";
import Slide from "@material-ui/core/Slide";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class DialogLote extends React.Component {
  state = {
    lote: undefined,
    error: undefined
  };

  sendValues = async () => {
    const filters = this.props.filters;
    const lote = this.state.lote;
    this.setState({ error: undefined });
    await client
      .mutate({
        mutation: LotesGraphQL.mutations.crearLote,
        variables: { lote, ...filters }
      })
      .then(res => {
        const message = `Se han asignado los canjes filtrados al lote seleccionado`;
        this.props.openNotification(message);
        this.props.onTableChange();
        this.props.handleClose();
      })
      .catch(error => {
        const message = error.graphQLErrors[0].message;
        this.setState({ error: message });
        // TODO: mostrar error por pantalla, las notificaciones tienen texto estatico por tema traducciones
        // this.props.openNotification(message);
      });
  };

  handleChange = () => event => {
    this.setState({ lote: event.target.value });
  };
  render() {
    const { open, handleClose, classes, totalCanjes } = this.props;
    return (
      <Fragment>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle
            id="alert-dialog-slide-title"
            className={classes.dialogTitle}
          >
            Nuevo Lote
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <Typography variant="subtitle2">
              {totalCanjes && `${_t("Cantidad de canjes")}: ${totalCanjes}`}
            </Typography>
            <FormControl>
              <TextField
                id="standard-name"
                label="Código del lote"
                className={classes.textField}
                value={this.state.lote}
                onChange={this.handleChange("lote")}
                margin="normal"
                error={this.state.error}
                helperText={this.state.error}
              />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="outlined" color="primary">
              Descartar
            </Button>

            <Button
              disabled={this.state.lote === undefined}
              onClick={this.sendValues}
              variant="contained"
              color="primary"
            >
              Crear Lote
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

DialogLote.defaultProps = {};

DialogLote.propTypes = {};

export default DialogLote;
